import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import "../Styles/Navbar.css";
import { Link } from "react-router-dom";
import logo from "../Assets/LOGO.png";
import AppointmentModal from "./AppointmentModal";

function Navbar() {
  const [nav, setNav] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openNav = () => {
    setNav(!nav);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="navbar-section">
      <h1 className="navbar-title">
        <Link to="/">
          <img src={logo} alt="NeuroCare Clinic Logo" className="navbar-logo" />
        </Link>
      </h1>

      {/* Desktop */}
      <ul className="navbar-items">
        <li>
          <Link to="/" className="navbar-links">
            Home
          </Link>
        </li>
        <li>
          <Link to="/services" className="navbar-links">
            Services
          </Link>
        </li>
        <li>
          <Link to="/about" className="navbar-links">
            About
          </Link>
        </li>
        <li>
          <Link to="/doctors" className="navbar-links">
            Doctors
          </Link>
        </li>
        <li>
          <Link to="/gallery" className="navbar-links">
            Gallery
          </Link>
        </li>
      </ul>

      <button className="navbar-btn" onClick={openModal}>
        Book Appointment
      </button>

      {/* Mobile */}
      <div className={`mobile-navbar ${nav ? "open-nav" : ""}`}>
        <div onClick={openNav} className="mobile-navbar-close">
          <FontAwesomeIcon icon={faXmark} className="hamb-icon" />
        </div>

        <ul className="mobile-navbar-links">
          <li>
            <Link onClick={openNav} to="/">
              Home
            </Link>
          </li>
          <li>
            <Link onClick={openNav} to="/services">
              Services
            </Link>
          </li>
          <li>
            <Link onClick={openNav} to="/about">
              About
            </Link>
          </li>
          <li>
            <Link onClick={openNav} to="/doctors">
              Doctors
            </Link>
          </li>
          <li>
            <Link onClick={openNav} to="/gallery">
              Gallery
            </Link>
          </li>
          <li>
            <a onClick={openNav} href="#contact">
              Contact
            </a>
          </li>
        </ul>
      </div>

      {/* Hamburger Icon */}
      <div className="mobile-nav">
        <FontAwesomeIcon
          icon={faBars}
          onClick={openNav}
          className="hamb-icon"
        />
      </div>

      <AppointmentModal isOpen={isModalOpen} onClose={closeModal} />
    </div>
  );
}

export default Navbar;
